/* unplugin-vue-components disabled */import script from "./BigFish.vue?vue&type=script&setup=true&lang=js"
export * from "./BigFish.vue?vue&type=script&setup=true&lang=js"

import "./BigFish.vue?vue&type=style&index=0&id=fe984626&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fe984626"]])

export default __exports__